import { render } from "./QuizType7.vue?vue&type=template&id=88dfb6a8&scoped=true"
import script from "./QuizType7.vue?vue&type=script&lang=js"
export * from "./QuizType7.vue?vue&type=script&lang=js"

import "./QuizType7.vue?vue&type=style&index=0&id=88dfb6a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dfb6a8"]])

export default __exports__